import {
  getTypographyDefaultColor,
  ImageSourceSizes,
  PlayBorderlessIcon,
  Typography
} from '@ag1/ui';
import clsx from 'clsx';
import CustomPortableText from 'shared/studio/PortableText/PortableText';
import IconPlayRound from 'shared/ui/Icon/picture/IconPlayRound';
import { VideoReviews as VideoReviewsProps } from 'types/studio/studio';

import { StudioBaseImageV2 } from 'shared/studio/StudioBaseImage/StudioBaseImage';
import styles from './VideoReviewsItem.module.scss';

type VideoReviewsItemProps = {
  onClick: () => void;
  item: VideoReviewsProps['videoReviews'][number];
  imageSizes: ImageSourceSizes;
  eagerLoading: boolean;
};

export const VideoReviewsItem = (props: VideoReviewsItemProps) => {
  const {
    onClick,
    item: { subtitle, title, caption, coverImage },
    imageSizes,
    eagerLoading
  } = props;

  return (
    <div className={styles.item}>
      <button type="button" className={styles.preview} onClick={onClick}>
        <StudioBaseImageV2
          image={coverImage}
          sizes={imageSizes}
          className={styles.coverImageContainer}
          eagerLoading={eagerLoading}
        />
        <div className={styles.iconButton}>
          <IconPlayRound />
        </div>
        <div className={clsx(styles.iconButton, styles.iconButtonHover)}>
          <div className={styles.iconButtonRound}>
            <PlayBorderlessIcon />
          </div>
        </div>
      </button>
      <div className={styles.info}>
        {subtitle && (
          <Typography
            color={getTypographyDefaultColor('new')}
            variant="body"
            size="3"
            noPadding
            className={styles.subtitle}>
            <CustomPortableText value={subtitle} />
          </Typography>
        )}
        {subtitle && title && <div className={styles.divider} />}
        <div className={styles.infoBody}>
          {title && (
            <Typography
              color={getTypographyDefaultColor('new')}
              variant="subtitle"
              size="2"
              noPadding
              className={styles.title}
              weight="700">
              <CustomPortableText value={title} />
            </Typography>
          )}
          {caption && (
            <Typography
              variant="captionMono"
              size="1"
              noPadding
              className={styles.caption}
              weight="400">
              <CustomPortableText value={caption} />
            </Typography>
          )}
        </div>
      </div>
    </div>
  );
};
